<nav #navbarElement class="navbar navbar-top text-dark pt-3 pb-3 bg-white border-bottom" id="navbar-main">
    <div class="d-flex align-items-center justify-content-between w-100">
        <!-- Brand y menú -->
        <div class="d-flex align-items-center gap-1">
            <button mat-icon-button *ngIf="showMenu" class="d-md-none me-2" (click)="showModal(false)">
                <mat-icon>menu</mat-icon>
            </button>

            <a [routerLink]="['/home']" class="d-flex align-items-center text-uppercase text-dark fw-bold text-decoration-none gap-2">
                <img class="logo-jamar-icon"
                src="./../../../../../assets/img/Logo_Jamar.png"
                alt="jamar_icon"
                />
            </a>

            <img *ngIf="c_emp" [src]="getFlagUrl(c_emp)" class="flag-img"/>
        </div>

        <!-- Acciones -->
        <div class="d-flex align-items-center gap-1">
            <button mat-icon-button (click)="showModal(true)" *ngIf="showSearch">
                <mat-icon>search</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Abrir menú de usuario">
                <mat-icon>account_circle</mat-icon>
            </button>

            <mat-menu #menu="matMenu" class="mat-menu pt-2">
                <div class="d-flex align-items-center gap-1 px-3 py-2">
                    <img
                        src="https://static.vecteezy.com/system/resources/previews/009/292/244/non_2x/default-avatar-icon-of-social-media-user-vector.jpg"
                        class="user-avatar-profile"
                        alt="Foto"
                        style="width: 40px;height: 40px;border-radius: 50%;object-fit: cover;"
                    />

                    <div class="d-flex flex-column">
                        <h4 class="m-0 fs-6 fw-semibold">{{user.nombre_usuario}}</h4>
                        <span class="fs-7 text-muted">({{user.usuario_aplicativo}})</span>
                    </div>
                </div>

                <mat-divider></mat-divider>

                <button mat-menu-item class="d-flex btn-menu align-items-center" (click)="deleteRecents()">
                    <mat-icon class="me-2 text-secondary">delete_sweep</mat-icon>
                    <span class="fs-6 text-muted">Eliminar recientes</span>
                </button>

                <button mat-menu-item class="d-flex align-items-center btn-menu" (click)="reloadModules()">
                    <mat-icon class="me-2">refresh</mat-icon>
                    <span class="fs-6 text-muted">Actualizar módulos</span>
                </button>

                <button mat-menu-item class="d-flex align-items-center btn-menu" (click)="openOldAdmin()">
                    <mat-icon class="me-2">language</mat-icon>
                    <span class="fs-6 text-muted">Antiguo Jamaradmin</span>
                </button>

                <button mat-menu-item class="d-flex align-items-center btn-menu" (click)="openSupport()">
                    <mat-icon class="me-2">settings</mat-icon>
                    <span class="fs-6 text-muted">Soporte técnico</span>
                </button>

                <mat-divider></mat-divider>

                <button mat-menu-item class="d-flex align-items-center btn-menu" (click)="logout()">
                    <mat-icon class="me-2 text-danger">logout</mat-icon>
                    <span class="fs-6 text-muted">Cerrar sesión</span>
                    </button>
            </mat-menu>
        </div>
    </div>
</nav>
